import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1, Large } from '@dbk/ui-text';
import { LoadingCircle } from '../../../components/common/loading';
import { Tabs, Tab } from '@dbk/ui-tabs';
import ReportStatement from '../report-statement';

class CurrentMonthlyStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timeline: 0,
      currentYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1,
      selectedYear: new Date().getFullYear(),
      modal: false,
      selectedMonth: 'January',
      currentMonthStatement: '',
    };

    this.onSelectYear = this.onSelectYear.bind(this);
    this.handlePress = this.handlePress.bind(this);
    this.props.setBusy();
    setTimeout(() => {
      this.props.getMonthlyStatementData({
        year: this.state.currentYear,
        month: this.state.selectedMonth,
        outputType: 'current',
      });
    }, 100);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.monthly.getMonthStatementList.length > 0) {
      this.setState({
        currentMonthStatement: this.props.monthly.getMonthStatementList,
      });
    }
  }

  componentWillUnmount() {
    this.props.reportClearData();
  }

  capitalize(s) {
    if (s)
      return (
        s[0].toUpperCase().trim() +
        s
          .slice(1)
          .toLowerCase()
          .trim()
      );
    return '';
  }

  handlePress(selectedObject) {
    this.setState({
      selectedMonth: this.capitalize(selectedObject.statementsMth),
      currentMonthStatement: '',
    });
    this.props.getMonthData({
      selectedYear: this.state.selectedYear,
      selectedMonth: this.capitalize(selectedObject.statementsMth),
      outputType: 'current',
      selectedItems: selectedObject.noOfStatements,
    });
  }

  onSelectYear(options) {
    const { currentYear, lastYear, selectedMonth } = this.state;
    this.setState({ timeline: options });
    this.props.setBusy();

    setTimeout(() => {
      if (options == 0) {
        this.setState({ selectedYear: currentYear, currentMonthStatement: '' });
        this.props.getMonthlyStatementData({
          year: currentYear,
          month: selectedMonth,
          outputType: 'current',
        });
      } else {
        this.setState({ selectedYear: lastYear, currentMonthStatement: '' });
        this.props.getMonthlyStatementData({
          year: lastYear,
          month: selectedMonth,
          outputType: 'current',
        });
      }
    }, 100);
    this.props.reportClearData();
  }

  renderMonthsList() {
    const { monthlyStatementsList } = this.props.monthly;
    const { i18n: { messages } } = this.props;
    if (
      monthlyStatementsList != undefined &&
      monthlyStatementsList != null &&
      monthlyStatementsList.length > 0
    ) {
      return (
        <div>
          <div className="margin-top-20">
            <ReportStatement
              reportList={monthlyStatementsList}
              selectedYear={this.state.selectedYear}
              pagefrom={'currentlyMonthly'}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Large style={{ textAlign: 'center' }}>
            {messages['app.reports.noRecords']}
          </Large>
        </div>
      );
    }
  }

  render() {
    const { currentYear, lastYear } = this.state;
    const { i18n: { messages } } = this.props;
    if (this.props.report.busy == true) {
      return (
        <div>
          <div>
            <LoadingCircle />
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="columns small-12 medium-12 large-12">
          <div className="module">
            <div>
              <H1 secondary>
                {messages['app.common.pageTitle.monthCurrStat']}
              </H1>
              <div>
                <div>
                  <Tabs
                    secondary
                    stretch
                    handleSelectedIndex={this.onSelectYear}
                    selectedIndex={this.state.timeline}
                  >
                    <Tab renderLabel={() => <Text>{currentYear}</Text>} />
                    <Tab renderLabel={() => <Text>{lastYear}</Text>} />
                  </Tabs>
                </div>
              </div>
              {this.renderMonthsList()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CurrentMonthlyStatement.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    setBusy: {
      $call: 'report.setBusy',
    },
    report: {
      busy: true,
    },
    getMonthlyStatementData: {
      $call: 'monthly.getMonthlyStatements',
    },
    getMonthData: {
      $call: 'monthly.getMonthStatement',
    },
    monthly: {
      monthlyStatementsList: true,
      getMonthStatementList: true,
    },
    reportClearData: {
      $call: 'report.clearData',
    },
  },
})(CurrentMonthlyStatement);
